import CommunityAdminPage from '@/modules/community-hub/admin/community-admin-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/admin/communities')({
  component: CommunityAdminPage,
});
